export default __webpack_public_path__ + "static/media/06.20.24 Minutes of the Meeting of the BOD.e3ad4674.pdf";